import React, { useState, useEffect, useRef } from 'react';

function throttle(callback, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      setInterval(callback, 10);
      callback();
      time = Date.now();
    }
  }
}

const useSticky = offset => {
  offset = offset !== undefined ? offset : 55;

  const [stuck, setStuck] = useState(false);

  const stickyRef      = useRef(null);
  const stickyStateRef = useRef(null);

  stickyStateRef.current = stuck;

  const handleScroll = () => {
    if (stickyRef.current) {
      let belowThreshold = stickyRef.current.getBoundingClientRect().top <= offset;

      if (belowThreshold !== stickyStateRef.current) {
        setStuck(belowThreshold);
      }
    }
  }

  useEffect(() => {
    const throttled = throttle(handleScroll, 200);
    window.addEventListener('scroll', throttled);

    return () => {
      window.removeEventListener('scroll', throttled);
    };
  }, []);

  return [stuck, stickyRef];
}

export default useSticky;
